module.exports = __webpack_public_path__ + "static/sportenMax-82c091d3ce7dcc48f7b1ff0dac1b4e41.svg";